/* sticky-atc.js — shows a mobile sticky Add-to-Cart bar once the real buy button
   scrolls out of view; delegates the click to Dawn's product form (AJAX cart). */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function initBar(bar) {
    if (bar.dataset.satcReady === '1') return;
    bar.dataset.satcReady = '1';

    var targetId = bar.getAttribute('data-target-button');
    var watchSel = bar.getAttribute('data-watch') || '.product-form__buttons';
    var realBtn = targetId ? document.getElementById(targetId) : null;
    var watchEl = document.querySelector(watchSel);
    var addBtn = bar.querySelector('[data-sticky-atc-add]');
    var priceEl = bar.querySelector('[data-sticky-atc-price]');
    if (!realBtn || !watchEl) return;

    var inView = true;
    function update() {
      var show = mq.matches && !inView;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (realBtn.disabled) return;
        realBtn.click();
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { inView = e.isIntersecting; });
        update();
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      io.observe(watchEl);
    }

    if (mq.addEventListener) { mq.addEventListener('change', update); }
    else if (mq.addListener) { mq.addListener(update); }

    function sync() {
      if (addBtn) addBtn.disabled = !!realBtn.disabled;
      if (priceEl) {
        var mainPrice = document.querySelector(
          '.product__info-container .price__sale .price-item--sale,' +
          '.product__info-container .price__regular .price-item--regular,' +
          '.product__info-container .price .price-item'
        );
        var txt = mainPrice && mainPrice.textContent ? mainPrice.textContent.trim() : '';
        if (txt) priceEl.textContent = txt;
      }
    }
    sync();

    try {
      var mo = new MutationObserver(sync);
      mo.observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });
      var infoC = document.querySelector('.product__info-container');
      if (infoC) mo.observe(infoC, { childList: true, subtree: true, characterData: true });
    } catch (e) { /* no-op */ }

    update();
  }

  function boot() {
    var bars = document.querySelectorAll('[data-sticky-atc]');
    for (var i = 0; i < bars.length; i++) initBar(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
